import Common from '../Common';

const Captcha = class extends Common {
	read = () => this.get("/captcha")

	verify = (captcha: string, domain: string = window.location.hostname, check_domain = false) =>
		this.postNoHeaders(
			"/captcha",
			{
				response: captcha,
				domain,
				check_domain
			}
		)
}

export default Captcha;
